import { createI18n } from 'vue-i18n'
import deLocale from './messages/de-DE'
import enLocale from './messages/en-EN'
import esLocale from './messages/es-ES'
import frLocale from './messages/fr-FR'
import itLocale from './messages/it-IT'

var _navigatorLocale = 'en'
if ('navigator' in window) {
    const lang = String(navigator.language).toLowerCase().slice(0, 2);
    _navigatorLocale = ['de','en','es','fr','it'].includes(lang) ? lang : 'en'
}

const messages = {
    de: { ...deLocale },
    en: { ...enLocale },
    es: { ...esLocale },
    fr: { ...frLocale },
    it: { ...itLocale }
}

const getLanguageName = (locale) => {
    switch (locale) {
        case 'de':
            return 'Deutsch'
        case 'en':
            return 'English'
        case 'es':
            return 'Español'
        case 'fr':
            return 'Français'
        case 'it':
            return 'Italiano'
    }
}

const getAllLocales = () => {
    return Object.keys(messages).map((code, id) => ({ code, id, name: getLanguageName(code) }))
}

const i18n = createI18n({
    legacy: false,
    locale: _navigatorLocale,
    fallbackLocale: 'en',
    messages
})

export {
    i18n,
    getLanguageName,
    getAllLocales
}
